//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TextField',
  props: {
    required: {
      type: Boolean,
      default: true
    },
    showError: {
      type: Boolean,
      default: false
    },
    displayBottom: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    maxlength: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedLabel() {
      return !this.displayBottom && this.showError && this.errorMessage ? this.errorMessage : this.label;
    },

    errorMsg() {
      return this.displayBottom && this.errorMessage && this.errorMessage;
    },

    inputClass() {
      return {
        error: this.showError,
        'has-value': this.value,
        'has-label': this.label,
        disabled: this.isDisabled
      };
    }

  }
};